import styled from 'styled-components';
import { ReactComponent as ApplePay } from 'static/images/logos/payments/apple-pay-white.svg';

function ApplePayComponent() {
   return (
     <Root>
       <ApplePay />
     </Root>
   );
 }
 
 export default ApplePayComponent;

const Root = styled.div`
svg {
  height: 25px;
}
`;